import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  clearModalErrors() {
    document.querySelectorAll(".settings-modal .setting-error").forEach((e) => { e.innerHTML = "" } )
  }
}
